import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';

export type Primitive = string | number | boolean | null | undefined;

export interface PaginationDTO<R> {
  result: R[];
  totalElements: number;
  page: number;
  totalPages: number;
}

export interface PaginationInput<SortBy, SortOrder, Filter> {
  page: number;
  sortBy?: SortBy;
  sortOrder?: SortOrder;
  filter: Filter;
}

export interface BcInfo {
  effectiveDate: string;
  zipCode: string;
  state: string;
  county: string;
}

// used in EmailService and EnrollmentService
export enum UserType {
  AOR = 'AOR',
  ADMIN = 'ADMIN',
}

export interface ToastInfo {
  showToast: boolean;
  toastType: ToastColorTypes;
  toastMessage: string;
}

export type TitleObject<T extends string> = Readonly<{
  [key in T]: string;
}>;
